/* @refresh reload */
import { render } from 'solid-js/web';

import App from './App.js';

// Local preview only: outside the Shopify admin, App Bridge never defines the `s-*` elements, so
// this gives them enough layout to review. Never loaded in a real embedded session.
if (import.meta.env.VITE_MOCK_API === '1') {
  await import('./dev-preview.css');
}

const root = document.getElementById('root');

if (!root) {
  throw new Error('Missing #root element — check index.html');
}

render(() => <App />, root);
